export default __webpack_public_path__ + "static/media/shoppingCartCheckout.eeb123be.svg";